export default "__VITE_ASSET__DxWaTgeY__"